<template>
  <a-card :bordered="false">
    <!-- v-has:dealerCreate="()=> {$router.push('/antiFleeingGoods/warehouseOut/fast_out')}" -->
    <a-button type="primary" v-has:antiWarehouseOutAddFast="fastShipping">
      <PlusOutlined />
      快速出库
    </a-button>
    <a-tabs class='m-t-10' v-model:activeKey="search.out_warehousing_type" @change='pageSearchChange'>
      <a-tab-pane :key="1" tab="经销商收货" :disabled='listLoading'></a-tab-pane>
      <a-tab-pane :key="2" tab="门店收货" :disabled='listLoading'></a-tab-pane>
    </a-tabs>
    <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="sn">出库单号</a-select-option>
            <a-select-option value="to">收货人名称</a-select-option>
            <a-select-option value="from">创建人</a-select-option>
            <a-select-option value="product_name">商品名称</a-select-option>
            <a-select-option value="mobile">收货人手机号</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item label="类型" name='create_type'>
        <a-select v-model:value="search.create_type" style="width:150px">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">快速出库</a-select-option>
          <a-select-option value="2">按单出库</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" ghost v-has:antiWarehouseOutExport="()=>{exportOpen()}">导出</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" ghost @click="viewVisble=true">查看生成报表</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='out_warehousing_sn' :columns='columns'
      :data-source='list' class="tableFixBox" :scroll="{ x: 'max-content'}">
      <template v-slot:to="{ record }">
        <p>{{record.to}}</p>
        {{record.to_mobile}}
      </template>
      <template v-slot:product_name="{ record }">
        <div v-if='record.product.length == 1'>
          <div v-for="(item,index) in record.product" :key='index'>
            <a-card-meta>
              <template #description>{{!item.product_sku_name || item.product_sku_name=='0' ?
                '单规格':item.product_sku_name}} - {{item.product_name}}</template>
            </a-card-meta>
          </div>
        </div>
        <div class="s_flex_ali" v-else>
          <p class="m-l-5 m-r-10">多商品</p>
          <a-button type="primary" size="small" @click='targetList=record.product;goodDetailVisible=true'>查看商品详情
          </a-button>
        </div>
      </template>
      <template v-slot:real_num="{record}">
        <p @click="codeDetailVisible=true;targetId=record.out_warehousing_sn" style="color:#f04635;cursor: pointer;">
          {{record.out_warehousing_real_num || '-'}}</p>
      </template>
      <template v-slot:action="{ record }">
        <a href="javascript:;" class="m-r-10"
          v-has:antiWarehouseOutDetail="()=> {$router.push('/antiFleeingGoods/documents/outboundDetails?id='+record.out_warehousing_sn)}">详情</a>
        <a href="javascript:;" v-has:antiWarehouseOutDel="()=>del(record)"
          v-if="record.out_warehousing_status!=3">删除</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal :keyboard="false" :maskClosable='false' v-model:visible="showAction" destroyOnClose :footer='null' centered>
    <p class="text-ac s_font_b fz-18 m-b-20">您还有未完成发货的出货单，是否继续上一次的编辑？</p>
    <p class="text-ac m-b-50">选择继续当前操作，未完成的单据将进行取消操作</p>
    <div class="text-ac">
      <a-button @click="selectAction('goOn')">继续当前操作</a-button>
      <a-button type="primary" class="m-l-20" @click="selectAction('goBack')">返回上一次编辑</a-button>
    </div>
  </a-modal>
  <a-modal :keyboard="false" :maskClosable='false' v-model:visible="codeDetailVisible" destroyOnClose :footer='null'
    :width="1200" centered>
    <codeDetail :id="targetId" />
  </a-modal>
  <a-modal title='商品详情' :keyboard="false" :maskClosable='false' v-model:visible="goodDetailVisible" destroyOnClose
    :footer='null' :width="1200" centered>
    <goodDetail :listdata="targetList" />
  </a-modal>
  <!-- 导出 -->
  <a-modal :keyboard="false" title="导出" v-model:visible="exportVisble" centered :footer="null" :width='500'
    destroyOnClose>
    <div>
      <div class="s_flex_ali">
        <span>创建时间：</span>
        <a-range-picker v-model:value="exportTime" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' />
      </div>
      <p style="font-size:14px;color:#999;margin-left:75px" class="m-t-10">导出筛选后的数据，创建时间间距不能大于31天</p>
      <a-button type="primary" class="m-t-40" style="margin-left:50%;transform:translateX(-50%)" @click="exportTable">导出
      </a-button>
    </div>
  </a-modal><!-- 报表 -->
  <a-modal :keyboard="false" title="查看报表" v-model:visible="viewVisble" centered :footer="null" :width='1000'
    destroyOnClose>
    <warehousTable :searchType="4"></warehousTable>
  </a-modal>

</template>
<script>
  import { PlusOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message, Modal } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getDealerLevelList } from "@/api/dealer";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import codeDetail from './components/codeDetail'
  import goodDetail from '../components/goodDetails.vue'
  import {
    getOutWarehousingList,
    closeOutWarehousing,
    outWarehousingClose,
    editFast,
    closeRefundOrder,
    outWarehousingExport
  } from "@/api/antiFleeing";
  import store from "@/store";
  import moment from 'moment';
  import config from "@/config";
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    page: 1,
    limit: 10,
    key_type: "sn",
    keyword: "",
    create_type: '',
    out_warehousing_type: 1
  };
  export default {
    components: { PlusOutlined, codeDetail, goodDetail },
    setup() {
      const state = reactive({
        info: store.state.user.info,
        time: [],
        exportTime: [],
        showAction: false,
        itemId: "", //上一次订单
        status: false, //false 出库 true 快速
        currentOrder: "", //当前订单
        goodDetailVisible: false,
        exportVisble: false,
        viewVisble: false
      });
      let columns = [
        {
          title: "出库单号",
          dataIndex: "out_warehousing_sn",
          key: "out_warehousing_sn",
        },
        {
          title: "收货人名称",
          dataIndex: "to",
          key: "to",
          slots: { customRender: "to" },
        },
        {
          title: "商品信息",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
          width: 300
        },
        {
          title: "出库数量",
          dataIndex: "out_warehousing_num",
          key: "out_warehousing_num",
        },
        {
          title: "实际数量",
          dataIndex: "out_warehousing_real_num ",
          key: "out_warehousing_real_num ",
          slots: { customRender: "real_num" },
        },
        {
          title: "类型",
          dataIndex: "create_type_text",
          key: "create_type_text",
        },
        {
          title: "状态",
          dataIndex: "out_warehousing_status_text",
          key: "out_warehousing_status_text",
        },
        // {
        //   title: "创建人",
        //   dataIndex: "create_role_name",
        //   key: "create_role_name",
        // },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
        },
        {
          title: "操作",
          key: "action",
          fixed: 'right',
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      //快速出货
      const fastShipping = async () => {
        // state.status = true;
        // let res = await editFast().then((res) => res.data).catch(error => error);
        //  if (iscode(res)) {
        //     const {order_no} =res.data;
        //      if(order_no!=0){ //有上次订单
        //          state.itemId = order_no;
        //          state.showAction = true
        //      }else{
        //         $router.push('/antiFleeingGoods/warehouseOut/fast_out')
        //      }
        //  }else{
        //     message.error(res.msg);
        //  }
        $router.push("/antiFleeingGoods/warehouseOut/fast_out");
      };

      // 选择操作
      const selectAction = async (type) => {
        if (type == "goOn") {
          const hide = message.loading("正在加载中...", 0);
          let res = await closeRefundOrder(state.itemId)
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res)) {
            //快速出库和出库
            state.status
              ? $router.push("/antiFleeingGoods/warehouseOut/fast_out")
              : $router.push(
                "/antiFleeingGoods/warehouseOut/ordinary_out?id=" + state.itemId
              );
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        } else {
          $router.push(
            "/antiFleeingGoods/warehouseOut/ordinary_out?id=" + state.itemId
          );
        }
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
      // 查看二维码详情
      const codeDetailVisible = ref(false)
      const targetId = ref('')

      // 删除
      const del = (item) => {
        Modal.confirm({
          centered: true,
          content: "确定关闭订单？",
          onOk: async () => {
            let res = await outWarehousingClose(item.out_warehousing_sn).then((res) => res.data);
            if (iscode(res, true)) {
              pageSearchChange();
            }
          },
        });
      }


      const exportOpen = async () => {
        if (state.time[0]) {
          state.exportTime = state.time;
        } else {
          state.exportTime = [moment().subtract(30, 'days'), moment()];
        }
        state.exportVisble = true;
      }
      //导出
      const exportTable = async function () {
        let dataNum = moment(state.exportTime[1]).diff(moment(state.exportTime[0]), 'days') + 1;
        console.log(dataNum)
        if (dataNum > 31) {
          message.error('时间间距不能大于31天！')
        } else {
          const hide = message.loading('正在加载中...', 0);
          let result = await outWarehousingExport({ ...search.value, start_time: moment(state.exportTime[0]).format('YYYY-MM-DD'), end_time: moment(state.exportTime[1]).format('YYYY-MM-DD'), limit: 5000 }).then(res => res.data).catch(error => error);
          setTimeout(hide);
          if (iscode(result)) {
            // window.open(config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='+result.data.key);
            message.success('导出中,文件请在生成报表查看！')
            state.exportVisble = false;
          }else{
            message.error(result.msg)
          }
        }
      }





      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(getOutWarehousingList, search.value);
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        codeDetailVisible,
        targetId,
        columns,
        changTime,
        selectAction,
        fastShipping,
        del,
        exportTable,
        exportOpen
      };
    },
  };
</script>